import { render, staticRenderFns } from "./loginModal.vue?vue&type=template&id=124c2486&scoped=true&"
import script from "./loginModal.vue?vue&type=script&lang=js&"
export * from "./loginModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124c2486",
  null
  
)

export default component.exports